// LOADER ........................
export const LOADER_HIDDEN = 'LOADER_HIDDEN'
export const LOADER_VISIBLE = 'LOADER_VISIBLE'

export const onLoaderHidden = () => ({
  type: LOADER_HIDDEN
})

export const onLoaderVisible = () => ({
  type: LOADER_VISIBLE
})

export const checkLoader = () => (dispatch, getState) => {
  const { loader } = getState()
  if (loader.loaderHidden) {
    dispatch(onLoaderVisible())
  }
}

// SLIDES ........................
export const SLIDE_LOADED = 'SLIDE_LOADED'

const slideLoaded = (totalNum, numLoaded) => ({
  type: SLIDE_LOADED,
  totalNum,
  numLoaded
})

export const loadSlides = (slides, numLoaded) => dispatch => {
  const totalNum = slides.length
  if (numLoaded >= totalNum) return

  const img = document.createElement('img')

  if (slides[numLoaded].fields !== undefined) {
    img.src = slides[numLoaded].fields.file.url
    img.addEventListener('load', () => {
      numLoaded = numLoaded + 1
      dispatch(slideLoaded(totalNum, numLoaded))
    })
  } else {
    numLoaded = numLoaded + 1
    dispatch(slideLoaded(totalNum, numLoaded))
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/actions/index.js